// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"640":"182629b2","1436":"f24d702d","9237":"bc06aa92"}[chunkId] + ".chunk.css";
};